<template>
  <form @submit.prevent="resetPassword">
    <h1
      class="Tit Tit--login"
      v-t="{path : 'login_reset_password_form_submit'}"
    ></h1>

    <div class="form--block">

      <div class="input--block w-100 mb-4">
        <label
          for=""
          class="form--label"
        >{{$t('PASSWORD').toUpperCase()}}</label>
        <div
          class="Form-field required"
          v-focus-input
        >
          <input
            type="password"
            class="Input-text"
            :placeholder="$t('PASSWORD')"
            v-model="passwordToSend"
            maxlength="72"
            v-autofocus
          >
        </div>
      </div>

      <div class="input--block w-100">
        <label
          for=""
          class="form--label"
        >{{$t('REPEAT_PASSWORD').toUpperCase()}}</label>
        <div
          class="Form-field required"
          v-focus-input
        >
          <input
            type="password"
            class="Input-text"
            :placeholder="$t('REPEAT_PASSWORD')"
            v-model="passwordToValidate"
            maxlength="72"
          >
        </div>

      </div>
      <div class="py-2 my-2">
        <button
          class="Button Button--primary w-100"
          v-t="{path : 'login_reset_password_form_submit'}"
          type="submit"
        ></button>

      </div>
    </div>

  </form>
</template>
<script>
export default {
  name: 'ResetPasswordForm',
  data () {
    return {
      passwordToSend: '',
      passwordToValidate: ''
    }
  },
  methods: {
    resetPassword () {
      if (this.passwordToSend !== this.passwordToValidate) return
      this.$emit('resetPassword', { password: this.passwordToSend })
    }
  }

}
</script>

<style scoped>
.Tit--login {
  text-align: center;
  font-size: 20px;
  font-weight: 300;
  line-height: 24px;
  margin-top: 20px;
  margin-bottom: 39px;
}

.login-form--button {
  margin-top: 38px;
}

.login-form--forgot-password {
  cursor: pointer;
  width: auto;
  font-weight: 300;
  color: var(--blue-action-1-active);
  font-size: 12px;
  letter-spacing: -0.26px;
  margin-top: -6px;
}
</style>
